/**
 * Arabic FAQ Translations
 * FAQ翻译模块 - 阿拉伯语
 */

import type { FaqTranslations } from '../../types';

export const arFaq: FaqTranslations = {
  title: 'الأسئلة الشائعة',
  subtitle: 'ابحث عن إجابات للأسئلة الشائعة حول سخانات الأشعة تحت الحمراء',
  contactTitle: 'هل لم تجد ما تبحث عنه؟',
  contactButton: 'اتصل بنا',
  questions: {
    whyChoose: {
      title: 'لماذا تختار سخانات الأشعة تحت الحمراء البعيدة؟',
      desc1: 'كفاءة تتجاوز معدلات التحويل: صحيح أن معدل تحويل الطاقة الظاهري لسخانات الأشعة تحت الحمراء البعيدة قد يكون أقل من مضخات الحرارة، لكن التوفير الفعلي في الطاقة وتجربة المستخدم يحكي قصة مختلفة. تم تصميم سخانات الأشعة تحت الحمراء البعيدة لتوفير الحرارة مباشرة للأشخاص والأشياء في الغرفة، وتقليل فقدان الحرارة وضمان وصول الدفء حيثما يلزم.',
      desc2: 'قوية وتوفير الطاقة: مع نطاق طاقة قوي من 1800 واط إلى 3200 واط، قادرة هذه السخانات على إنتاج حرارة كبيرة. لكن كفاءتها في توزيع الحرارة تعني أنك يمكنك تحقيق الدفء المطلوب مع استهلاك طاقة أقل، مما يوفر في فواتير الكهرباء.',
      desc3: 'تجربة راحة معززة: يُعرف شعاع الأشعة تحت الحمراء البعيدة بقدرته على اختراق المواد والأنسجة الحية بعمق أكبر، مما يوفر دفئًا أكثر انتظامًا وراحة. الاختلاف الكبير هو أنك ستكون "النار" الأخرى في الفضاء، وليس Nuggets الدجاج في مقلاة الهواء.',
      desc4: 'حل تدفئة متعدد الاستخدامات: في الأيام الباردة بشكل خاص، يمكن أن تكمل سخانات الأشعة تحت الحمراء البعيدة أنظمة التدفئة الأخرى، مما يضمن أن مساحتك دافئة ومريحة باستمرار.',
    },
    getPrice: {
      title: 'كيفية الحصول على أسعار سخانات الأشعة تحت الحمراء البعيدة؟',
      desc: 'يمكنك النقر على صفحة الاتصال بنا وترك رسالة حول ما تحتاجه وموقعك. سنقدم عرض أسعار للاستفسارات بناءً على احتياجاتك الدقيقة.',
    },
    services: {
      title: 'ما الخدمات التي تقدمها؟',
      item1: 'عينات موحدة (قطعتين فأكثر) شحن سريع، 3-15 يومًا، خيارات محدودة للمقابس',
      item2: 'طلبات متوسطة موحدة (20 قطعة فأكثر)، 15-30 يومًا، تخصيص خفيف (الشعار، تغليف المنتج، تغليف الشحن)',
      item3: 'طلبات كبيرة للمنتجات الموحدة (300~2000 قطعة فأكثر)، 45-60 يومًا، خدمات قيمة مضافة اختيارية (مظهر خاص، وظائف إضافية، معايير خاصة)',
      note: 'الخدمات المذكورة أعلاه تنطبق على منتجات سخانات الكهرباء.',
    },
    energyEfficient: {
      title: 'هل سخانات الأشعة تحت الحمراء البعيدة أكثر كفاءة في استخدام الطاقة؟',
      desc1: 'تحول سخانات الأشعة تحت الحمراء البعيدة الطاقة الكهربائية إلى إشعاع الأشعة تحت الحمراء البعيدة، ثم تمتصه الأشياء في الغرفة، مما يؤدي إلى ارتفاع درجة الحرارة. يعتمد كفاءة سخان الأشعة تحت الحمراء البعيدة على عدة عوامل، بما في ذلك حجم الغرفة والعزل ونوع السخان. في المتوسط، تُعتبر سخانات الأشعة تحت الحمراء البعيدة أكثر كفاءة من أنظمة التدفئة التقليدية لأنها تسخن الأشياء مباشرة، مما يقلل من كمية الطاقة المفقودة بالحمل.',
      desc2: 'ومع ذلك، قد تختلف كفاءة الطاقة الفعلية بناءً على الاستخدام والعوامل البيئية. يُنصح بالرجوع إلى مواصفات المنتج ومراجعات العملاء لتحديد كفاءة الطاقة.',
    },
    coveringArea: {
      title: 'ما هي المساحة التي يغطيها سخان JH؟',
      desc: 'تعتمد المساحة المغطية على حجم الغرفة وظروف العزل وارتفاع السقف. تم تصميم سخاناتنا لتسخين المساحات بكفاءة بناءً على مواصفات واطها.',
    },
    howWork: {
      title: 'كيف تعمل سخانات JH بالأشعة تحت الحمراء؟',
      desc1: 'يسخن سخان الحمل التقليدي الهواء الدائر أولاً. تسخن ألواح التسخين بالأشعة تحت الحمراء الأشخاص والأشياء أولاً، وليس الهواء المحيط. تسخن الأشعة تحت الحمراء الجلد في وقت قصير، ويخترق هذا الدفء الدورة الدموية حول الجسم. لذلك تشعر بدفء مريح قريبًا بينما يكون الهواء المحيط أبرد.',
      benefit1: 'إنها تسخن جسمك مباشرة بطريقة الأشعة تحت الحمراء البعيدة، بدلاً من إهدار الكثير من الطاقة لتسخين الهواء.',
      benefit2: 'مقارنة بسخانات الإشعاع الأخرى، فإنها أكثر كفاءة بكثير في تحويل الكهرباء إلى حرارة، لأنها تستخدم تقنية النانو الجديدة.',
      benefit3: 'إنها أكثر راحة من سخانات الكهرباء الأخرى.',
      desc2: 'يوضح هذا الرسم الفرق بين السخان التقليدي وسخان الأشعة تحت الحمراء.',
    },
    operatingCost: {
      title: 'كم تكلفة تشغيل سخانات JH بالأشعة تحت الحمراء؟',
      desc1: 'بافتراض سعر كهرباء يبلغ 0.35 يورو لكل كيلوواط ساعة، تتراوح تكاليف تشغيل سخانات JH من 0.63 يورو في الساعة (1800 واط) إلى 1.12 يورو في الساعة (3200 واط).',
      desc2: 'للمقارنة، فإن سخان الفناء من نوع "الفطر" الأقل كفاءة بقوة 13 كيلوواط يكلف 4.55 يورو في الساعة للتشغيل، أي أربعة أضعاف الطراز الأقوى والأطول.',
    },
    difference13A14A: {
      title: 'ما الفرق بين سخان 13A و 14A؟',
      desc: 'الاختلاف هو فقط في تصميم لوحة الإشعاع، أما عنصر التسخين الداخلي وهيكله متماثلان، وكفاءة التسخين متماثلة أيضًا.',
    },
    installationHeight: {
      title: 'ما هو أفضل ارتفاع للتركيب؟',
      desc: 'ارتفاع التركيب الموصى به هو 1.8 إلى 2.5 متر.',
    },
    whyShortWave: {
      title: 'لماذا الموجة القصيرة؟',
      desc1: 'بشكل أساسي، كلما كانت الموجة أقصر، مرت عبر الهواء بسهولة أكبر. تولد الأشعة تحت الحمراء ذات الموجة القصيرة الحرارة عن طريق تسخين الجسم الذي تصطدم به، دون تسخين الهواء المحيط. حرارة فعالة وفورية بدون تسخين مسبق.',
      desc2: 'مثال جيد على هذا النمط من العمل هو التأثير الذي يحدث عندما يمشي شخص من الظل إلى ضوء الشمس. على الرغم من أن درجة الحرارة المحيطة تظل كما هي، إلا أنهم يشعرون بدرجة الحرارة أكثر دفئًا بشكل ملحوظ تحت الإشعاع الشمسي المباشر.',
    },
  },
};
